import React from 'react';
import { Card, Button, Tag, Divider } from 'antd';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCalendarAlt, faClock, faBell } from "@fortawesome/free-solid-svg-icons";
import { formatDateTime, formatDateTimeFromNow } from '../../../../utils/functions';
import SOURCES from '../../../../utils/constants';

const EnhancedNotificationDetails = ({
    notification,
    onMarkAsRead
}) => {
    if (!notification) return null;

    const isUnread = notification.readStatus === SOURCES.NOTIFICATION_UNREAD;

    return (
        <div className="sm:!p-4 p-2 bg-gray-50 h-full">
            <Card className="shadow-sm !p-0">
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-4 sm:mb-6">
                    <div className="flex items-center gap-3">
                        <div className="bg-blue-50 sm:size-12 size-10 flex justify-center items-center rounded-full text-primary flex-shrink-0 transition-all">
                            <FontAwesomeIcon icon={faBell} size="lg" className="scale-90 sm:scale-100" />
                        </div>
                        <div>
                            <h3 style={{ fontSize: "clamp(15px, 4.5vw, 18px)" }} className="font-semibold m-0 text-gray-800 leading-tight">Notification Details</h3>
                        </div>
                    </div>
                    <div className="w-full sm:w-auto flex sm:justify-end">
                        {isUnread ? (
                            <Button
                                icon={<FontAwesomeIcon icon={faCheck} />}
                                onClick={() => onMarkAsRead(notification)}
                                className='!text-primary !border-primary hover:!border-primary hover:!bg-primary hover:!text-white w-full sm:w-auto h-9 sm:h-10 px-4 font-medium transition-all shadow-sm'
                            >
                                Mark as Read
                            </Button>
                        ) : (
                            <Tag color="success" className="px-3 py-1 text-sm m-0 border-green-100 rounded-md font-medium ">
                                Status: <span className='capitalize font-semibold'>{notification.readStatus}</span>
                            </Tag>
                        )}
                    </div>
                </div>

                <Divider />

                <div className="mb-6">
                    <h4 className="text-[11px] font-bold text-gray-500 uppercase tracking-widest mb-3">Message</h4>
                    <div className="bg-gray-50 p-3 sm:p-4 rounded-lg border border-gray-100 shadow-inner">
                        <p style={{ fontSize: "clamp(13px, 4vw, 15px)" }} className="text-gray-800 leading-relaxed whitespace-pre-wrap mb-0">
                            {notification.notifyText}
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div className="bg-white p-3 rounded-lg border border-gray-100 shadow-sm transition-transform active:scale-[0.98]">
                        <span className="text-[10px] text-gray-400 font-bold uppercase block mb-1">Date Time</span>
                        <div className="flex items-center gap-2.5 text-gray-700 text-sm font-semibold">
                            <FontAwesomeIcon icon={faCalendarAlt} className="text-primary/60 scale-90" />
                            {formatDateTime(notification.createdAt)}
                        </div>
                    </div>
                    <div className="bg-white p-3 rounded-lg border border-gray-100 shadow-sm transition-transform active:scale-[0.98]">
                        <span className="text-[10px] text-gray-400 font-bold uppercase block mb-1">Relative Time</span>
                        <div className="flex items-center gap-2.5 text-gray-700 text-sm font-semibold">
                            <FontAwesomeIcon icon={faClock} className="text-primary/60 scale-90" />
                            {formatDateTimeFromNow(notification.createdAt)}
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default EnhancedNotificationDetails;
